import { SubscriptionComponentCardSettings } from './types';

export const subscriptionComponentCardSettings: SubscriptionComponentCardSettings =
  {
    componentVariants: {
      variant: {
        prop: 'variant',
        variants: {
          primary: {
            backgroundColor: 'primary.extraLight',
          },
          secondary: {
            backgroundColor: 'white.main',
          },
        },
      },
    },
  };
